import {
  FormControl,
  FormLabel,
  SimpleGrid,
  Stack,
  Switch,
  useColorModeValue,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';

import Card from 'components/card/Card';

import TextField from 'components/fields/TextField';
import { onFieldContentModified } from '../../../../../../store/preview/previewSlice';
import { useDispatch } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit'; // Import Dispatch type from @reduxjs/toolkit

interface Badge {
  gasId: number;
  gasAssetImage: string;
  gasAssetName: string;
}

const TakewayScreen: React.FC<{
  handleChange: (e: any) => void;
  formData: any;

  setFormData: React.Dispatch<React.SetStateAction<any>>;
}> = ({ handleChange, formData, setFormData }) => {
  const [value, setValue] = useState<String>();

  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const [textTakeawayTyped, setTextTakeawayTyped] = React.useState('');
  const textareaRef = useRef(null);
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (textareaRef.current) {
      const textarea = textareaRef.current;
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  });

  ///////////////////////ScreenStates////////////////////////////////

  useEffect(() => {
    if (!formData.gameTakeawayContent) {
      setTextTakeawayTyped('');
    } else {
      setTextTakeawayTyped(formData.gameTakeawayContent);
    }
  }, [formData.gameTakeawayContent]);

  let previousLength = 0;
  const handleInput = (event: any) => {
    const bullet = '\u2022';
    const currentValue = event.target.value;
    const newLength = currentValue.length;
    setValue(event.target.value);

    if (event.nativeEvent instanceof InputEvent) {
      const keyCode = (event.nativeEvent as InputEvent).inputType;
      if (keyCode === 'insertLineBreak') {
        event.preventDefault();
        event.target.value = `${currentValue}${bullet} `;
      } else if (keyCode === 'deleteContentBackward') {
        const lastBulletIndex = currentValue.lastIndexOf(bullet);
        if (lastBulletIndex !== -1 && lastBulletIndex === newLength - 1) {
          event.target.value = currentValue.slice(0, lastBulletIndex);
        }
      } else {
        if (previousLength === 0 && currentValue.length <= 1) {
          event.target.value = `${bullet} ${currentValue}`;
        }
        if (newLength > previousLength) {
          if (currentValue.endsWith(bullet) || currentValue.trim() === bullet) {
            event.preventDefault();
            event.target.value = `${currentValue} `;
          }
        }
      }
    }
    dispatch(
      onFieldContentModified({
        gameId: formData.gameId,
        modifiedField: event.target.name,
        updatedValue: event.target.value,
      }),
    );
    setFormData((prev: any) => ({
      ...prev,
      gameTakeawayContent: event.target.value,
    }));
    previousLength = event.target.value.length;
  };

  return (
    <Stack direction="column" gap="20px">
      <Card>
        <SimpleGrid columns={{ base: 1, md: 1 }} gap="20px">
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent={'space-between'}
            mt="20px"
          >
            <FormLabel
              htmlFor="email-"
              mb="10px"
              ml="10px"
              fontSize="sm"
              fontWeight="bold"
              color={textColorPrimary}
            >
              Show Takeaways
            </FormLabel>
            <Switch
              isChecked={formData.gameIsShowTakeaway === 'true' ? true : false}
              color="#fff"
              colorScheme="brandScheme"
              size="md"
              id="gameIsShowTakeaway"
              name="gameIsShowTakeaway"
              onChange={handleChange}
            />
          </FormControl>

          {formData.gameIsShowTakeaway === 'true' && (
            <div>
              <TextField
                ref={textareaRef}
                mb="0px"
                disabled={
                  formData?.gameIsShowTakeaway === 'true' ? false : true
                }
                placeholder="eg. Try to understand what went wrong before reacting"
                label="Takeaways Content"
                id="gameTakeawayContent"
                name="gameTakeawayContent"
                value={formData?.gameTakeawayContent}
                onChange={handleInput}
                rows="5"
                wrap="hard"
                resize="none" // Prevent manual resizing
                style={{
                  border:
                    formData.gameIsShowTakeaway === 'true' &&
                    !formData?.gameTakeawayContent
                      ? '1px solid red'
                      : '1px solid #ced4da',
                  minHeight: '350px',
                }}
              />
            </div>
          )}
        </SimpleGrid>
      </Card>
    </Stack>
  );
};
export default TakewayScreen;
